// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cs+3J","overlay":"styles_overlay__k3j-G","logoWrapper":"styles_logoWrapper__suAwX","tooltip":"styles_tooltip__cWaJ3","sup":"styles_sup__qqje0"};